import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbDatepickerConfig, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'mlp-ng-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [NgbDatepickerConfig]
})

export class DatepickerSharedComponent implements OnInit, OnChanges {
    @Input() toggle = new EventEmitter();
    @Input() date: NgbDateStruct;
    @Input() ngDatepickerConfig: NgbDatepickerConfig;

    // tslint:disable-next-line:prefer-output-readonly
    @Output() chosenDate = new EventEmitter<NgbDateStruct>();
    @ViewChild('d') datepicker: NgbInputDatepicker;

    constructor(private config: NgbDatepickerConfig) {}

    ngOnInit(): void {
        this.toggle.subscribe(_ => this.datepicker.toggle());
    }

    ngOnChanges(changes: SimpleChanges): void {
        const dateConfig = changes['ngDatepickerConfig'];
        if (dateConfig) Object.assign(this.config, this.ngDatepickerConfig);
    }

    onDateSelect(event: NgbDateStruct): void {
        this.chosenDate.emit(event);
    }
}
